const auditState = {
  0: '待审核',
  1: '审核通过',
  2: '审核不通过'
}

export {auditState}